<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('cancel')">
        <div class="modal-container" @click.stop>
          <div class="modal-header d-sm-block d-none">
            <slot name="header"><h1>Purchase Offer Reject</h1></slot>
          </div>

          <div class="d-sm-none">
            <b-button-close @click="$emit('cancel')"/>
            <h4>Purchase Offer Reject</h4>
          </div>

          <div class="modal-body">
            <slot name="body">
              <div v-if="!submittedSuccessfully">
                <b-row>
                  <b-col cols="12" md="4">User Email :</b-col>
                  <b-col cols="12" md="8">
                    {{ purchaseOffer.userEmail }}
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="4">Offered at :</b-col>
                  <b-col cols="12" md="8">
                    {{ purchaseOffer.offeredAt }}
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="4">Product Key :</b-col>
                  <b-col cols="12" md="8">
                    {{ purchaseOffer.productKey }}
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="4">Variant Key :</b-col>
                  <b-col cols="12" md="8">
                    {{ purchaseOffer.variantKey }}
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="4">Comment :</b-col>
                  <b-col cols="12" md="8">
                    {{ purchaseOffer.positionComment }}
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12">
                    <div class="alert alert-warning text-center">
                      <strong>
                        Are you sure you want to reject this purchase offer ?
                      </strong>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="4">
                    <b-button variant="danger" class="btn-offer" @click="$emit('cancel')">No</b-button>
                  </b-col>
                  <b-col cols="12" md="4"></b-col>
                  <b-col cols="12" md="4">
                    <b-button variant="success" class="btn-offer" @click="rejectPurchaseOffer">Yes</b-button>
                  </b-col>
                </b-row>
              </div>
              <div v-else>
                <div class="alert alert-success alert-offer-value-success">
                  <b-iconstack scale="1.5">
                    <b-icon stacked icon="circle-fill"></b-icon>
                    <b-icon stacked icon="check" variant="white" scale="0.8"></b-icon>
                  </b-iconstack>
                  Successfully rejected offer<br /><br />
                  <b-button variant="success" @click="$emit('cancel')">
                    <b-icon-x/> Close
                  </b-button>
                </div>
              </div>
              <b-col cols="12" v-if="error.rejectPurchaseOffer.isError === true" class="text-left mt-3">
                <div class="alert alert-danger" role="alert">
                  Something went wrong. If this problem persists, please contact the IT team. Add the following details
                  to better pinpoint the problem:<br />
                  Code: <strong>{{ error.rejectPurchaseOffer.code }}</strong
                  ><br />
                  Message:
                  <strong>{{ error.rejectPurchaseOffer.message }}</strong>
                </div>
              </b-col>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import apiAuth from 'src/clients/apiAuth';
import constants from 'src/constants/constants';

export default {
  name: 'PurchaseOfferRejectDialog',
  props: ['purchaseOffer'],
  data() {
    return {
      currentlySending: false,
      submittedSuccessfully: false,
      error: {
        rejectPurchaseOffer: {
          isError: false,
          code: null,
          message: '',
        },
      },
    };
  },
  methods: {
    resetError(errorKey) {
      this.error[errorKey].isError = false;
      this.error[errorKey].code = null;
      this.error[errorKey].message = '';
    },
    setError(errorKey, code, message) {
      this.error[errorKey].isError = true;
      this.error[errorKey].code = code;
      this.error[errorKey].message = message;
    },
    rejectPurchaseOffer() {
      let options = {
        method: 'post',
        url: constants.url.offerService.baseUrl + constants.url.offerService.api.purchaseOffers.reject,
        data: {
          purchaseOfferId: this.purchaseOffer.purchaseOfferId,
        },
      };
      this.currentlySending = true;
      this.resetError('rejectPurchaseOffer');
      apiAuth(options)
        .then(() => {
          this.submittedSuccessfully = true;
          this.currentlySending = false;
          this.$emit('purchase-offer-rejected');
        })
        .catch((error) => {
          this.setError(
            'rejectPurchaseOffer',
            error.response.status,
            error.response.data.message + ' / Purchase Offer ID: ' + options.data.purchaseOfferId,
          );
          this.currentlySending = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-offer {
  width: 100%;
}
</style>
